// נתוני הפרויקטים נטענים מ-projects.json (טקסטים) ומ-galleryManifest.json (תמונות).
// galleryManifest.json נוצר אוטומטית ע"י scripts/generate-gallery-manifest.js לפי
// התמונות שקיימות בפועל ב-public/images — אין לערוך אותו ידנית.
//
// להוספת פרויקט חדש: הריצו `npm run add-project` (או ראו HOW-TO-ADD-PROJECT.md).
import projectsJson from './projects.json';
import galleryManifest from './galleryManifest.json';

const projects = projectsJson.map((project) => {
  const media = galleryManifest[project.folder] || { main: null, gallery: [] };
  return {
    ...project,
    // תמונה ראשית: בחירה מפורשת ממערכת הניהול > קובץ main > התמונה הראשונה
    mainImage: project.mainImage || media.main || (media.gallery.length > 0 ? media.gallery[0] : '/images/assets/main.png'),
    gallery: media.gallery.filter((src) => src !== project.mainImage),
  };
});

export const findProject = (idOrSlug) =>
  projects.find((p) => p.slug === idOrSlug || String(p.id) === String(idOrSlug));

export default projects;
